export default __webpack_public_path__ + "static/NWP-logo-1c03946b80f62023452dacb2a07297ab.webp";